import { hero as heroStatic } from "../data/content";
import { useContent } from "../context/ContentContext";
import { Waveform } from "./HeroArt";

export const Hero = () => {
  const { content } = useContent();
  const h = content.hero;
  const roles = (h.description || "").split(/,|\sy\s/).map((w) => w.trim()).filter(Boolean);
  return (
  <section id="inicio" data-testid="hero-section" className="section-anchor relative overflow-hidden">
    <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 pt-40 pb-28 lg:pt-56 lg:pb-44">
      <div>
        <h1 data-testid="hero-name" className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
          {h.name}
          <span data-testid="hero-stage-name" className="block font-serif-display italic font-medium text-2xl sm:text-3xl text-[#C0C7D1] mt-3">
            — {h.stageName}
          </span>
        </h1>
        <p data-testid="hero-roles" className="hero-roles font-serif-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl text-white mt-7 flex flex-wrap items-center gap-x-4 gap-y-1 tracking-wide">
          {roles.map((word, i) => (
            <span key={i} className="flex items-center gap-x-4">
              {i > 0 && <span className="text-[#0057FF]" aria-hidden="true">·</span>}
              <span className="glow-silver whitespace-nowrap">{word}</span>
            </span>
          ))}
        </p>
        <p data-testid="hero-tagline" className="text-lg sm:text-xl text-blue-100 mt-8 max-w-xl leading-relaxed">
          “{h.tagline}”
        </p>
        <div className="flex flex-wrap gap-4 mt-10">
          <a
            href={heroStatic.ctaPrimary.target}
            data-testid="cta-conoce-historia"
            className="btn-primary rounded-full px-7 py-3 text-sm font-semibold"
          >
            {heroStatic.ctaPrimary.label}
          </a>
          <a
            href={heroStatic.ctaSecondary.target}
            data-testid="cta-contacto"
            className="btn-outline-light rounded-full px-7 py-3 text-sm font-semibold"
          >
            {heroStatic.ctaSecondary.label}
          </a>
        </div>
      </div>
    </div>
    <div className="absolute bottom-0 inset-x-0 z-0 pb-4">
      <Waveform />
    </div>
  </section>
  );
};
